interface IVideoPlayer {
   play(): void;
   pause(): void;
   getIsPaused(): boolean;
   getCurrentTime(): number;
   setCurrentTime(time: number): void;
   getDuration(): number;
   getSrc(): string;
   setSrc(src: string): void;
   setVolume(volume: number): void;
   setScrubbing(isScrubbing: boolean): void;
   getIsSeeking(): boolean;
   on(eventName: string, handler: (e: any) => void): void;
   one(eventName: string, handler: () => void): void;
   dispose(): void;
   getIsDisposed(): boolean;
   getIsNullInstance(): boolean;
}

export const nullVideoPlayerFactory = (initialData?: Partial<IVideoPlayer>): IVideoPlayer => Object.assign({
   play: () => null,
   pause: () => null,
   getIsPaused: () => true,
   getCurrentTime: () => -1,
   setCurrentTime: (time: number) => null,
   getDuration: () => 0,
   getSrc: () => 'src',
   setSrc: (src: string) => null,
   setVolume: (volume: number) => null,
   setScrubbing: (isScrubbing: boolean) => null,
   getIsSeeking: () => false,
   on: (eventName: string, handler: () => null) => null,
   one: (eventName: string, handler: () => null) => null,
   dispose: () => null,
   getIsDisposed: () => false,
   getIsNullInstance: () => true
}, initialData);

export default IVideoPlayer;
